import React, { useState } from 'react';
import FancyTabs from './FancyTabs';
import FancyRow from './FancyRow';

/* The whole Fancy block:
   newtab_collect ("Fancy" tab) → market_section.twoOddsSection
     → fancy-tab (dark fancy-subtabs bar)
     → fancy-tab-content: NO/YES header + the fancy rows.
   Main tab and sub-tabs are React-controlled; the row list is static for now
   (real API can filter rows by the active sub-tab later). */
export default function FancySection({ fancy, onSelectBet }) {
  const [mainTab, setMainTab] = useState(0);
  const [subTab, setSubTab] = useState(0);

  return (
    <div className="newtab_collect tab-container">
      <FancyTabs variant="main" tabs={fancy.mainTabs} active={mainTab} onChange={setMainTab} />
      <div className="tab-content">
        <div role="tabpanel" className="tab-pane active">
          <div className="market_section twoOddsSection">
            <div className="fancy-tab">
              <FancyTabs variant="sub" tabs={fancy.subTabs} active={subTab} onChange={setSubTab} />
            </div>
            <div className="tab-content">
              <div role="tabpanel" className="tab-pane active">
                <div>
                  <div className="fancy-tab-content">
                    {/* NO / YES header */}
                    <div className="row align-items-center oddsHeader">
                      <div className="col-lg-6 col-md-6 col-8 px-0" />
                      <div className="col-lg-2 col-md-2 col-4 px-0 d-none d-md-block" />
                      <div className="col-lg-2 col-md-2 col-4 px-0">
                        <div className="btn-group">
                          <button className="w-100 bg-light lay">no</button>
                          <button className="w-100 bg-light back">yes</button>
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-2 col-4 px-0 d-none d-md-block" />
                    </div>
                    {fancy.rows.map((row) => (
                      <FancyRow key={row.name} row={row} onSelectBet={onSelectBet} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
